export enum Product {
  HOUSE = 'house',
  APARTMENT = 'apartment',
  NS = 'ns',
  PETS = 'pets',
  SPORT = 'sport-ns',
  MITE = 'mite',
}
